const FewClouds = (props) => (
  <svg
    width="38"
    height="39"
    viewBox="0 0 38 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.0625 22.0151C13.0625 20.0188 13.6545 18.0673 14.7636 16.4074C15.8727 14.7474 17.4491 13.4537 19.2935 12.6897C21.1379 11.9258 23.1674 11.7259 25.1254 12.1153C27.0834 12.5048 28.882 13.4661 30.2936 14.8778C31.7052 16.2894 32.6666 18.088 33.056 20.0459C33.4455 22.0039 33.2456 24.0335 32.4816 25.8779C31.7177 27.7222 30.4239 29.2987 28.764 30.4078C27.1041 31.5169 25.1526 32.1089 23.1562 32.1089H11.2812C10.3329 32.1081 9.39616 31.9008 8.53605 31.5014C7.67595 31.102 6.91313 30.5201 6.30062 29.7962C5.6881 29.0722 5.24059 28.2236 4.98918 27.3092C4.73776 26.3948 4.68848 25.4367 4.84476 24.5013C5.00104 23.566 5.35913 22.6759 5.89413 21.8929C6.42914 21.1099 7.12824 20.4528 7.94283 19.9673C8.75743 19.4818 9.66798 19.1795 10.6112 19.0814C11.5544 18.9833 12.5077 19.0918 13.4048 19.3994"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8251 8.46736L11.2065 4.95898"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.22676 11.3954L4.30853 9.35205"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.04588 16.7178L2.53751 17.3364"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.1472 9.64797L19.1906 6.72974"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.66589 20.138C6.9974 19.363 6.50365 18.4532 6.21825 17.4704C5.93285 16.4876 5.86249 15.4548 6.01196 14.4424C6.16142 13.4299 6.52721 12.4615 7.08443 11.6031C7.64165 10.7447 8.37723 10.0164 9.24114 9.46768C10.105 8.91899 11.077 8.56281 12.0909 8.42338C13.1047 8.28395 14.1368 8.36454 15.1167 8.65966C16.0966 8.95478 17.0015 9.45751 17.7698 10.1337C18.538 10.8098 19.1517 11.6435 19.5689 12.578"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default FewClouds
